var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "14px",
    viewBox: "0 0 38 43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1044.000000, -204.000000)",
    id: "icon/fuel"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1039.000000, 201.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iocn/delivery-van"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F9F9F9",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3516784,10.6748543 L34.6056281,3 L32.6013668,4.7598392 L37.2942714,10.1371256 C34.4589749,10.2837789 32.2591759,12.8257688 32.6013668,15.7099497 C32.8457889,17.9097487 34.6545126,19.7673568 36.8543116,20.1095477 C38.0764221,20.256201 39.2496482,20.0117789 40.1784523,19.3762814 L40.1784523,38.3434372 C40.1784523,39.5655477 39.2985327,40.7387739 38.0275377,40.8365427 C36.6098894,40.983196 35.4366633,39.9077387 35.4366633,38.441206 L35.4366633,29.984201 C35.4366633,27.4910955 33.432402,25.4868342 30.9392965,25.4868342 L29.7660704,25.4868342 L29.7660704,10.0882412 C29.7660704,6.61744724 26.9307739,3.73326633 23.4110955,3.73326633 L11.3855276,3.73326633 C7.91473367,3.73326633 5.03055276,6.56856281 5.03055276,10.0882412 L5.03055276,45.5294472 L29.8638392,45.5294472 L29.8638392,28.126593 L31.0370653,28.126593 C32.0636382,28.126593 32.8946734,28.9576281 32.8946734,29.984201 L32.8946734,38.2456683 C32.8946734,40.9343116 34.8989347,43.2807638 37.5386935,43.4274171 C40.4228744,43.6229548 42.9159799,41.3253869 42.9159799,38.3923216 L42.9159799,14.7811457 C42.9159799,13.2657286 42.3293668,11.7503116 41.3516784,10.6748543 Z M37.6853467,17.5186734 C36.3654673,17.5186734 35.2900101,16.4432161 35.2900101,15.1233367 C35.2900101,13.8034573 36.3654673,12.728 37.6853467,12.728 C39.0052261,12.728 40.0806834,13.8034573 40.0806834,15.1233367 C40.0806834,16.4432161 38.9074573,17.5186734 37.6853467,17.5186734 Z M20.4780302,36.7791357 C19.646995,37.5612864 18.5715377,38.0012462 17.447196,38.0012462 C16.3228543,38.0012462 15.2962814,37.5612864 14.4163618,36.7791357 C12.8031759,35.2148342 12.8031759,32.5750754 14.4163618,30.9618894 L16.6650452,28.7620905 C17.0561206,28.3710151 17.7405025,28.3710151 18.0826935,28.7620905 L20.3313769,30.9618894 C22.0912161,32.526191 22.0912161,35.1659497 20.4780302,36.7791357 Z M9.43015075,19.1807437 L9.43015075,11.2614673 C9.43015075,10.0882412 10.3589548,9.15943719 11.5321809,9.15943719 L23.6555176,9.15943719 C24.8287437,9.15943719 25.7575477,10.0882412 25.7575477,11.2614673 L25.7575477,19.1807437 L9.43015075,19.1807437 L9.43015075,19.1807437 Z",
    id: "Shape",
    fill: "#818894"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusFuel);
export default __webpack_public_path__ + "static/media/bus-fuel.f2edc3f6a629ac5df24678247e4f1d10.svg";
export { ForwardRef as ReactComponent };